<footer class="main-footer">
  <div class="float-right d-none d-sm-block"><b>Version</b> 1.0.0</div>
</footer>
